export default {
    state: {
        apartmentSizes: [],
        supplierAddresses: {},
    },

    getters: {
        apartmentSizes: function (state) { return state.apartmentSizes },
        supplierAddresses: function (state) { return state.supplierAddresses },
    },

    mutations: {
        setApartmentSizes: function (state, payload) {
            state.apartmentSizes = payload
        },
        setSupplierAddresses: function (state, payload) {
            state.supplierAddresses = payload;
        }
    }
}



// WEBPACK FOOTER //
// ./assets/vue/houseModel/store/metaDataState.js